import styled from '@emotion/styled';
import { Title } from 'components/Title';

export const ProductListContainer = styled.ul`
    padding: ${({ theme }) => theme.base.spacing[4]};
`;

export const ListContainer = styled.ul`
    max-width: 100%;
`;

export const ProductListTitle = styled(Title)`
    margin-bottom: ${({ theme }) => theme.base.spacing[1]};
`;
